import React, { useState } from 'react'
import { getProverbsChapter } from '../selectors/getProverbsChapter'

function getCurrentDate() {
  return window.__TEST_DATE__ || new Date()
}

function ProverbsOfTheDay() {
  const [translation, setTranslation] = useState(() => localStorage.getItem('translation') ?? 'kjv')

  const handleToggle = () => {
    const next = translation === 'kjv' ? 'web' : 'kjv'
    localStorage.setItem('translation', next)
    setTranslation(next)
  }

  const { chapter, kjv, web } = getProverbsChapter(getCurrentDate())
  const verses = translation === 'kjv' ? kjv : web
  const label = translation === 'kjv' ? 'King James Version' : 'World English Bible'

  return (
    <article aria-label="Proverbs of the Day" className="py-4">
      <header className="mb-4">
        <p
          className="text-uppercase fw-semibold text-muted mb-1"
          style={{ fontSize: '0.7rem', letterSpacing: '0.1em' }}
        >
          Proverbs of the Day
        </p>
        <h2 className="display-5 fw-bold mb-3">Proverbs {chapter}</h2>
        <p className="text-muted fst-italic mb-3" style={{ lineHeight: '1.7' }}>
          Proverbs has 31 chapters — one for each day of the month. It's a habit I try to
          maintain every day: read the chapter that matches today's date and let it sit with
          you. This site keeps that going.
        </p>
        <hr className="opacity-25" />
      </header>

      <ol className="list-unstyled mb-0">
        {verses.map((text, i) => (
          <li key={i} className="d-flex gap-3 mb-2" style={{ lineHeight: '1.7' }}>
            <span
              className="text-muted fw-semibold flex-shrink-0 text-end"
              style={{ minWidth: '1.5rem', fontSize: '0.75rem', paddingTop: '0.25rem' }}
            >
              {i + 1}
            </span>
            <span>{text}</span>
          </li>
        ))}
      </ol>

      <footer className="mt-4 pt-3 border-top d-flex align-items-center justify-content-between flex-wrap gap-2">
        <small className="text-muted">
          Translation:{' '}
          <span data-testid="translation-label" className="fw-semibold text-dark">
            {label}
          </span>
        </small>
        <button
          type="button"
          className="btn btn-link btn-sm p-0 text-muted"
          onClick={handleToggle}
        >
          Switch to {translation === 'kjv' ? 'World English Bible' : 'King James Version'}
        </button>
      </footer>
    </article>
  )
}

export default ProverbsOfTheDay
